import { render, staticRenderFns } from "./componentsTree.vue?vue&type=template&id=754f13d3&scoped=true"
import script from "./componentsTree.vue?vue&type=script&lang=js"
export * from "./componentsTree.vue?vue&type=script&lang=js"
import style0 from "./componentsTree.vue?vue&type=style&index=0&id=754f13d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f13d3",
  null
  
)

export default component.exports